'use client'

import ReactTooltip from 'react-tooltip'
import { useEffect } from 'react'
import { IoIosCopy } from 'react-icons/io'
import { IoCheckmark } from 'react-icons/io5'
import { useState } from 'react'

const copyToClipboard = async (text: string): Promise<void> => {
	try {
		await navigator.clipboard.writeText(text)
	} catch (error) {
		console.error('Failed to copy text: ', error)
	}
}

export function CopyTooltip({
	secretValue,
	iconSize = 'lg',
	className
}: {
	secretValue: string
	iconSize?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
	className?: string
}) {
	const [isCopied, setIsCopied] = useState<boolean>(false)

	const handleCopyClick = async () => {
		await copyToClipboard(secretValue)
		setIsCopied(true)
	}

	useEffect(() => {
		if (isCopied) {
			const timer = setTimeout(() => {
				setIsCopied(false)
			}, 2000)
			return () => clearTimeout(timer)
		}
	}, [isCopied])

	return (
		<>
			<button
				data-for="copy-tip"
				data-tip={isCopied ? 'Copied' : 'Copy to clipboard'}
				onClick={handleCopyClick}
				className={`bg-transparent ${className}`}
			>
				{isCopied ? (
					<IoCheckmark className={`text-${iconSize} text-[#2EFF13]`} />
				) : (
					<IoIosCopy className={`text-${iconSize}`} />
				)}
			</button>
			<ReactTooltip id="copy-tip" place="top" effect="solid" class="custom-tooltip top" />
		</>
	)
}
